import request from '@/utils/request';

/**
 * 山姆订单列表
 */
export function getSamOrderList(params) {
  return request({
    url: '/admin/lyp/order/sm/list',
    method: 'POST',
    data: params || {}
  });
}

/**
 * 订单状态（分组）
 */
export function getOrderStatusGrouped() {
  return request({
    url: '/admin/lyp/order/order-status/grouped',
    method: 'POST'
  });
}

/**
 * 山姆订单导出
 */
export function exportSamOrder(params) {
  return request({
    url: '/admin/sm/order/export',
    method: 'GET',
    params: params
  });
}

/**
 * 山姆订单详情
 */
export function getSamOrderDetail(orderNo) {
  return request({
    url: '/admin/lyp/order/sm/detail',
    method: 'POST',
    data: {
      orderNo: orderNo
    }
  });
}

/**
 * 积分/福豆使用明细
 * @param {string|number} orderNo 订单号
 */
export function getIntegralLog(orderNo) {
  return request({
    url: "/admin/order/station/getIntegralLog/".concat(orderNo),
    method: 'get'
  });
}